import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {TimeZoneSearchModel} from "../time-zone-search.model";
import {
    registerSelectEditControl
} from "../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {
    AbstractMultiSelectEditControlComponent
} from "../../framework/entity/edit/edit-controls/select-edit-controls/abstract-multi-select-edit-control.component";

@Component({
    selector: "wbo-time-zone-multi-select-edit-control",
    templateUrl: "../../framework/entity/edit/edit-controls/select-edit-controls/multi-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(TimeZoneMultiSelectEditControlComponent),
        provideSearchModel(TimeZoneSearchModel)
    ]
})
export class TimeZoneMultiSelectEditControlComponent extends AbstractMultiSelectEditControlComponent<TimeZoneSearchModel> {
    constructor(model: TimeZoneSearchModel, injector: Injector) {
        super(model, injector, "timeZone", "timeZone");
    }
}
